import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { ColumnChooserModel } from '../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../models/common/ColumnFilterModel';

/**
 * Genel Giderler > Sigorta / Kasko (28.10.2026, #501 / #502). Tarihler poliçedeki gibi (01.01.2026 - 01.01.2027);
 * durum ve kalan gün sunucuda bugüne göre hesaplanır. Maliyete yalnız Tutar girer; teminatlar gider değildir.
 */

export const SIGORTA_SAYFASI = 'Genel Giderler > Sigorta / Kasko';

export interface SigortaListIstegi {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    columnChooser: ColumnChooserModel[] | undefined
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
    ids?: string[]
    /** Araç kartı "Poliçeler" sekmesi. */
    vehicleId?: string
}

export const ilkSigortaListIstegi: SigortaListIstegi = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    columnFilters: []
}

export interface SigortaDosyasi { id: string, ad: string, url: string }

export interface SigortaKaydi {
    sigortaPolicesiId: string
    belgeTuru: number
    belgeTuruAdi: string
    vehicleId: string
    plaka?: string
    aracCinsi?: string
    markaModel?: string
    modelYili?: number
    policeNo: string
    durum: number
    durumAdi: string
    baslangicTarihiStr: string
    baslangicTarihiDeger: string
    bitisTarihiStr: string
    bitisTarihiDeger: string
    kalanGun: number
    uyari: number
    uyariAdi: string
    sigortaFirmasiId: string
    sigortaFirmasi?: string
    acenteId: string
    acente?: string
    tutar: number
    currencyTypeId: string
    dovizCinsi?: string
    kur: number
    tutarTL: number
    teminatBedeli: number
    ekTeminatBedeli: number
    aciklama?: string
    kopyalananPoliceId?: string
    dosyalar?: SigortaDosyasi[]
    isSelected?: boolean
}

export interface SigortaToplamlari {
    tutar?: number
    dovizCinsi?: string
    farkliDoviz: boolean
    tutarTL: number
}

export interface SigortaKaydet {
    id?: string
    belgeTuru?: number
    vehicleId?: string
    policeNo?: string
    baslangicTarihi?: string
    bitisTarihi?: string
    sigortaFirmasiId?: string
    acenteId?: string
    tutar?: number
    currencyTypeId?: string
    teminatBedeli?: number
    ekTeminatBedeli?: number
    aciklama?: string
    kopyalananPoliceId?: string
    /** Düzenlemede kalan mevcut evraklar; listede olmayan evrak silinir. */
    kalanDosyaIdleri: string[]
}

export interface SigortaKaydetSonucu {
    kayit: SigortaKaydi
    /** Aynı araç + türde tarihi çakışan poliçe varsa (kayıt yine yapılır). */
    cakismaUyarisi?: string
}

export interface SigortaSecenek { value: string, label: string, ek?: string }

export interface SigortaSecenekleri {
    belgeTurleri: { value: number, label: string }[]
    durumlar: { value: number, label: string }[]
    sigortaFirmalari: SigortaSecenek[]
    acenteler: SigortaSecenek[]
    dovizCinsleri: SigortaSecenek[]
    varsayilanDovizId?: string
    dosyaUzantilari: string[]
    azamiDosyaMb: number
}

export interface SigortaAracBilgisi {
    vehicleId: string
    plaka: string
    aracCinsi?: string
    markaModel?: string
    modelYili?: number
    /** Treyler (Dorse) / Yarı Römork: Araç Sigortası seçilemez. */
    treylerMi: boolean
    aktif: boolean
}

export interface SigortasizArac {
    vehicleId: string
    plaka: string
    aracCinsi?: string
    sonBitis?: string
    sonrakiBaslangic?: string
}

const cagir = async (yol: string, inputObj: any) => {
    try {
        console.log('SERVICE CALL - Sigorta/' + yol, JSON.stringify(inputObj));

        const resp = await axios.post(Helpers.getEndpoint() + '/Sigorta/' + yol, inputObj);

        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class SigortaService {
    static getList(inputObj: SigortaListIstegi) { return cagir('GetListPagingAndFilter', inputObj); }
    static exportList(inputObj: SigortaListIstegi) { return cagir('ExportList', inputObj); }
    static getById(id: string) { return cagir('GetById', { id }); }
    static sil(ids: string[]) { return cagir('Sil', { ids }); }
    static secenekler() { return cagir('Secenekler', {}); }
    static plakalar() { return cagir('Plakalar', {}); }
    static sigortasizAraclar(belgeTuru: number) { return cagir('SigortasizAraclar', { belgeTuru }); }

    /** Kayıt + yeni evraklar tek istekte: "veri" = JSON, "dosyalar" = dosyalar. */
    static async kaydet(inputObj: SigortaKaydet, dosyalar: File[]) {
        try {
            const form = new FormData();
            form.append('veri', JSON.stringify(inputObj));
            dosyalar.forEach(d => form.append('dosyalar', d));

            const resp = await axios.post(Helpers.getEndpoint() + '/Sigorta/Kaydet', form, { headers: { 'Content-Type': 'multipart/form-data' } });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}
